import {ReactElement, ReactNode} from 'react'
import Radio from '@material-ui/core/Radio'
import Button from '@material-ui/core/Button'
import Link from '@material-ui/core/Link'
import {Trans} from 'react-i18next'

import {WithdrawalMethodValues} from '../../constants'
import messages from '../../../../../../assets/messages'
import {useStyles} from './styles'

type WithdrawalMethodItemProps = {
  activeWithdrawalMethod: WithdrawalMethodValues | null,
  isEdit: boolean,
  title: ReactNode,
  processingTimeSubtitle: ReactNode,
  icon: ReactNode,
  value: WithdrawalMethodValues,
  onChange: (method: WithdrawalMethodValues) => void,
  onAddPayoutClick: (method: WithdrawalMethodValues) => void,
}

function WithdrawalMethodItem(props: WithdrawalMethodItemProps): ReactElement {
  const {
    activeWithdrawalMethod,
    isEdit,
    value,
    title,
    processingTimeSubtitle,
    icon,
    onAddPayoutClick,
    onChange
  } = props
  const classes = useStyles()
  const isChecked	= activeWithdrawalMethod === value

  const handleRadioClick = () => onChange(value)

  const handleAddPayoutClick = () => onAddPayoutClick(value)

  return (
    <div className={classes.container}>
      <div className={classes.column}>
        <Radio classes={{root: classes.rootRadio}} color="primary" checked={isChecked} onClick={handleRadioClick} />
        <div className={classes.info}>
          <div className={classes.title}>{title}</div>
          <div className={classes.subTitle}>{processingTimeSubtitle}</div>
        </div>
      </div>
      <div className={classes.column}>
        {icon}
        <Button disabled={!isChecked} component={Link} className={classes.button} onClick={handleAddPayoutClick}>
          {isEdit ? (
            <Trans {...messages.edit} />
          ) : (
            <span>
              +<Trans {...messages.addPayoutAccount} />
            </span>
          )}
        </Button>
      </div>
    </div>
  )
}

export {WithdrawalMethodItem}
